import { navigation } from './navigation.en';
import labelAndDesc from './labelAndDesc.en';
import errorLabels from './errorLabels.en';

const adminEn = {
  translation: {
    navigation,
    labelAndDesc,
    errorLabels,
    formattedDate: '{{date, DD/MM/YYYY}}',
    header: {
      envType: {
        dx: 'DX',
        tx: 'TX',
        mx: 'MX',
      },
      status: {
        settlement: {
          open: 'Settlement Open',
          closed: 'Settlement Closed',
        },
        payments: {
          chfOpen: 'Detokenization (CHF) - Open',
          eurOpen: 'Detokenization (EUR) - Open',
          chfClosed: 'Detokenization (CHF) - Closed',
          eurClosed: 'Detokenization (EUR) - Closed',
        },
      },
      processingDate: 'Processing Date: {{date, DD/MM/YYYY}}',
    },
    dashboard: {
      title: 'Here you will find your dashboard',
      text: 'Get an overview of the activities as well as important events and news from the distributed ledger network at a glance (coming soon).',
      actions: {
        title: 'Quick Actions',
        SIs: 'SIs',
        PIs: 'PIs',
        CAs: 'CAs',
        movements: 'Movements',
        holdings: 'Holdings',
      },
      stats: {
        title: 'Instructions and Events',
        sis: 'Settlement Instructions',
        allegements: 'Allegements',
        openInstr: 'Open Instructions',
        closedInstr: 'Closed Instructions',
        pis: 'Payment Instructions',
        cas: 'Corporate Actions',
        ownAssetEvents: 'Own Asset Events',
        payingAgentEvents: 'Paying Agent Events',
        ownHoldingsEvents: 'Own Holdings Events',
        view: 'View',
      },
    },
    referenceData: {
      accounts: {
        actions: {
          viewHoldings: 'View holdings',
        },
      },
      fractionalisationAssets: {
        overview: {
          title: 'Fractionalisation Assets',
          create: 'Add Asset',
          delete: 'Delete',
        },
        submit: {
          title: 'Warning',
          yes: 'Yes',
          no: 'No',
          warningMessage: 'You selected one of your fractionalised assets, but captured a round lot. Do you want to continue?',
        },
      },
      standingSettlementInstructions: {
        overview: {
          title: 'On-Exchange Trades SSI Overview',
          create: 'New SSI',
        },
      },
      assets: {
        overview: {
          title: 'Asset Overview',
          create: 'New Asset',
          update: 'Update Asset',
          warning: 'Warning',
          import: 'Import',
        },
        submit: {
          create: 'Save',
          cancel: 'Cancel',
          continue: 'Continue',
          submitConfirm:
            'You opted for the C/A Auto-Creation service. You are trying to modify attribute(s) used by this serivce, please ensure that there is no inconsistency with already created or future C/As.',
          warningDifferentCurrency: 'Interest Currency is different from the Denomination Currency. Do you want to continue?',
          warningInterestTypeChanges:
            'You are modifying crucial term sheet attributes, please ensure this change has no implications to other SDX members.',
          warningBusinessDayConvetionChanges:
            'You are modifying crucial term sheet attributes, but a C/A with a different Business Day Convention was already processed. Please ensure this change has no implications to other SDX members.',
          warningDepositaryReceiptInactive:
            'The Issuer Agent has not signed the required side letter. This Depositary Receipt asset will be created as INACTIVE and can only be activated once the side letter is signed. Do you want to continue?',
          warningTaxAgreementInactive:
            'The Issuer Agent has not signed the tax agreement. This asset will be created as INACTIVE and can only be activated once the tax agreement is signed. Do you want to continue?',
        },
      },
      currencies: {
        overview: {
          title: 'Currency Overview',
          create: 'New Currency',
        },
      },
      transferRestriction: {
        overview: {
          title: 'Transfer Restrictions',
          create: 'New Transfer Restriction',
        },
      },
      eligibilityOnRestrictedAsset: {
        overview: {
          title: 'Assets Eligibility',
          create: 'Add Asset',
        },
      },
      listingRequest: {
        overview: {
          title: 'Connexor IBT Termsheets',
          create: 'Add Request',
          showRawIbt: 'Show Raw IBT',
          tabs: {
            accepted: 'Open',
            imported: 'Imported in CSD',
          },
        },
        modal: {
          title: 'Raw IBT Data',
          close: 'Close',
        },
        selectorHeader: {
          title: '{{entity}} selection',
          noMatch: 'No results for "{{term}}"',
          memberLabel: 'Select Member',
        },
      },
    },
    transactions: {
      settlementInstructions: {
        overview: {
          title: 'Settlement Instructions',
          create: 'Create Instruction',
          tabs: {
            allegements: 'Allegements',
            open_instructions: 'Open Instructions',
            closed_instructions: 'Closed Instructions',
            all_instructions: 'All Instructions',
          },
        },
        action: {
          counterInstruction: 'Counter instruction',
        },
      },
      cryptoDepositWithdrawals: {
        overview: {
          title: 'Crypto Deposits / Withdrawals',
          create: 'Create Instruction',
          tabs: {
            open_instructions: 'Open Instructions',
            closed_instructions: 'Closed Instructions',
            all_instructions: 'All Instructions',
          },
        },
        action: {
          counterInstruction: 'Counter instruction',
        },
      },
      paymentInstructions: {
        overview: {
          title: 'Payment Instructions',
          create: 'Create Instruction',
          tabs: {
            openInstructions: 'Open Instructions',
            closedInstructions: 'Closed Instructions',
            allInstructions: 'All Instructions',
          },
        },
      },
    },
    technicalIssuer: {
      cashTransactions: {
        title: 'Cash Transactions',
        actions: {
          triggerButton: 'Instruct transfer',
          createManualPI: 'Create Manual PI',
          createSpecialPI: 'Create Special PI',
        },
      },
      outstandingTokens: {
        title: 'Outstanding FIAT Cash Token Balance',
      },
      memberBalanceReport: {
        overview: {
          title: 'Cash by Member',
        },
      },
      memberAccountBalanceReport: {
        overview: {
          title: 'Cash by Member by Account',
        },
      },
      movementReport: {
        overview: {
          title: 'Movement Report',
        },
      },
      currencyEligibilityList: {
        overview: {
          titleEligibleMembers: 'Eligible',
          titleNonEligibleMembers: 'Not Eligible',
        },
        action: {
          addToEligibilityList: {
            buttonTitle: 'Add to Eligibility List',
            modalTitle: 'Proceed With "Add Eligibility" Action?',
          },
        },
        success: {
          title: 'Success',
          message: 'Successfully performed action «{{action}}» on entity of type «{{entity}}».',
        },
        error: {
          title: 'Something went wrong!',
          message: 'Error while performing the "{{actionLabel}}" action.',
        },
      },
      assetTransactions: {
        overview: {
          title: 'Asset Transactions',
          create: 'Create Instruction',
          tabs: {
            allegements: 'Allegements',
            open_instructions: 'Open Instructions',
            closed_instructions: 'Closed Instructions',
            all_instructions: 'All Instructions',
          },
        },
        action: {
          counterInstruction: 'Counter instruction',
        },
      },
      settlementInstructionReport: {
        overview: {
          title: 'Settlement Instruction Report',
        },
      },
      paymentInstructionReport: {
        overview: {
          title: 'Payment Instruction Report',
        },
      },
    },
    holdings: {
      tabs: {
        assets: 'Assets',
        cash: 'Cash',
      },
      actions: {
        triggerButton: 'Instruct transfer',
        createSettlementInstruction: 'Create Settlement Instruction',
        createPaymentInstruction: 'Create Payment Instruction',
        createDepositWithdrawalInstruction: 'Create Deposit or Withdrawal',
      },
      selectorHeader: {
        title: '{{entity}} selection',
        historicalHoldingsTitle: 'Historical Holdings',
        currentHoldingsTitle: 'Current Holdings',
        noMatch: 'No results for "{{term}}"',
        accountLabel: 'Select Account',
        dateLabel: 'Select Date',
      },
    },
    movements: {
      title: 'Movements',
      tabs: {
        assets: 'Assets',
        cash: 'Cash',
      },
    },
    corporateActions: {
      tabs: {
        issuerAgentEvents: 'Issuer Agent Events',
        payingAgentEvents: 'Paying Agent Events',
        ownHoldingsEvents: 'Own Holdings Events',
        allEvents: 'All Events',
      },
      overview: {
        title: 'C/A Overview',
        create: 'Create event',
      },
      action: {
        viewInstructions: 'View instructions',
        viewCurrencyBreakdown: 'Currency Breakdown',
      },
      currencyBreakdown: {
        title: 'Currency Breakdown',
        currency: 'Currency',
        amount: 'Amount',
        total: 'Total',
        noData: 'No currency breakdown data available yet',
        close: 'Close',
      },
      submit: {
        title: 'Warning',
        yes: 'Yes',
        no: 'No',
        warningMessage: 'Are you sure no Tax Exemption Code is to be applied?',
        wcbdcPaWarning:
          'The selected Paying Agent is currently not eligible for wCBDC. If this remains unchanged, the C/A will be executed in tCHF. Do you wish to continue with this Paying Agent?',
      },
    },
    corporateActionProfile: {
      overview: {
        title: 'C/A Profile Overview',
        create: 'Create C/A Profile',
      },
    },
    operations: {
      taxIncomeCodes: {
        overview: {
          title: 'Tax Income Codes',
          create: 'New Tax Income Code',
        },
      },
      taxExemptionCodes: {
        overview: {
          title: 'Tax Exemption Codes',
          create: 'New Tax Exemption Code',
        },
      },
      tradingParticipants: {
        overview: {
          title: 'Trading Participant Overview',
          create: 'New Trading Participant',
        },
      },
      scheduler: {
        title: 'Scheduler',
        trigger: 'Trigger',
        triggerCurrencyWindow: 'Close {{currency}} Detokenization',
        autoscheduler: {
          enable: {
            label: 'Enable Autoscheduler',
            modalTitle: 'Proceed With "Enable Autoscheduler" Action?',
          },
          disable: {
            label: 'Disable Autoscheduler',
            modalTitle: 'Proceed With "Disable Autoscheduler" Action?',
          },
          success: {
            title: 'Success',
            message: 'Successfully performed action «{{action}}».',
          },
          error: {
            title: 'Something went wrong!',
            message: 'Error while performing the "{{action}}" action.',
          },
        },
        error: 'Something went wrong!',
      },
      businessAuditLog: {
        title: 'Business Audit Log',
        details: {
          title: 'Business Audit Log Details',
        },
      },
      businessCalendar: {
        title: 'Business Calendars',
      },
      businessCalendarDay: {
        title: 'Business Calendar Days',
        create: 'Create Business Calendar Entry',
        multiUpload: {
          btn: 'Multiple Days Upload',
          title: 'Upload multipe days from Excel file',
          msg1: 'Your Excel file has to include this header row:',
          msg2: 'Calendar | Date | IsBusinessDay | Name',
          cancel: 'Cancel',
          submit: 'Submit',
          errorMsg: 'Sth went wrong! Pick different file.',
          progress: 'Upload in progress...',
        },
      },
      subbalanceTransfers: {
        overview: {
          title: 'Cash Sub-balance Transfer',
          create: 'Create Transfer',
        },
      },
      assetSubbalanceTransfers: {
        overview: {
          title: 'Asset Sub-balance Transfer',
          create: 'Create Transfer',
          tabs: {
            openInstructions: 'Open Instructions',
            closedInstructions: 'Closed Instructions',
            allInstructions: 'All Instructions',
          },
        },
      },
    },
    whitelistedAddresses: {
      overview: {
        title: 'Whitelisted Addresses Overview',
        create: 'Create address',
        tabs: {
          deposit_addresses: 'Deposit Addresses',
          withdrawal_addresses: 'Withdrawal Addresses',
        },
      },
    },
    accounts: {
      overview: {
        title: 'Account Overview',
        create: 'Create Account',
      },
      processingUsages: {
        confirmChange: 'Account Processing Usage Removal',
        confirm: 'Confirm',
        cancel: 'Cancel',
        warning:
          'Removing a processing usage from an account impacts the default behaviour of the system and could have unwanted consequences if the processing usage is not assigned to another account. Do you wish to proceed?',
      },
    },
    externalAccounts: {
      overview: {
        title: 'External Account Overview',
        create: 'Create External Account',
      },
    },
    members: {
      overview: {
        title: 'Member Overview',
        create: 'Create Member',
      },
      removeBic: {
        confirmChange: 'Member Node BIC Removal',
        confirm: 'Confirm',
        cancel: 'Cancel',
        warning:
          'Before removing the Member Node BIC, it shall be checked that the "EoD Auto-Detokenization tCHF" service is not active for that member. Do you wish to proceed?',
      },
    },
    legalEntities: {
      overview: {
        title: 'Legal Entity Overview',
        create: 'Create Legal Entity',
      },
      submit: {
        create: 'Create',
        cancel: 'Cancel',
        submitConfirm: 'I confirm hereby to have the necessary approval from SIX GroupTax to create a legal entity with this Tax Domicile.',
      },
    },
    externalEntities: {
      overview: {
        title: 'External Entities Overview',
        create: 'Create External Entity',
        tabs: {
          custodial: 'Custodial Entities',
          non_custodial: 'Non-Custodial Entities',
        },
      },
    },
    xeyes: {
      action: {
        approve: 'Approve',
        approveAndShow: 'Approve & Show Entity',
        reject: 'Reject',
        cancel: 'Cancel Request',
        back: 'Back to Overview',
        create: 'Create Instruction',
        duplicate: 'Duplicate',
        modal: {
          title: 'Proceed with <<{{actionLabel}} Request>> action?',
          subtitle: 'Following request will be impacted:',
        },
      },
      approvalStatus: {
        pendingComplianceReview: 'Pending Compliance Review',
        compliance: 'Compliance',
        rejectedByCompliance: 'Rejected By Compliance',
      },
      decidePendingAction: {
        success: {
          title: 'Success!',
          message: 'Changes have been {{decision}}',
        },
        error: {
          title: 'Something went wrong!',
          message: 'Error while updating the changes',
        },
      },
      operations: {
        new: 'New',
        change: 'Change',
        CancelSettlementInstruction: 'Cancel',
        SuspendEntity: 'Suspend',
        UnsuspendEntity: 'Unsuspend',
        ReleaseCsdHold: 'Release CSD Hold',
        SetCsdHold: 'Set CSD Hold',
        CancelPaymentInstruction: 'Cancel',
        HardCancelPaymentInstruction: 'Hard Cancel',
        WithdrawCorporateActionEvent: 'Withdraw',
        CompleteDepositAddressSetup: 'Enter L1 Address',
        ActivateDepositAddress: 'Complete Compliance Check and Activate',
        ActivateWithdrawalAddress: 'Complete Compliance Check and Activate',
        CompleteCryptoDepositInitialComplianceCheck: 'Complete Initial Compliance Check',
        CompleteCryptoDepositExternalProcessing: 'Complete External Processing',
        CompleteCryptoDepositFinalComplianceCheck: 'Complete Final Compliance Check',
        CompleteCryptoWithdrawalComplianceCheck: 'Complete Compliance Check',
        StartCryptoWithdrawalExternalProcessing: 'Start External Processing',
        CompleteGrossCryptoWithdrawalExternalProcessing: 'Complete External Processing',
        CompleteNetCryptoWithdrawalExternalProcessing: 'Complete External Processing',
      },
      item: {
        newEntity: 'New {{entity}}',
        changeEntity: 'Change {{entity}}',
        executeAction: 'Execute {{action}}',
        seeDetails: 'See details',
        by: 'by',
        on: 'on',
        dateFormat: 'DD/MM/YYYY',
      },
      list: {
        title: '4-Eyes',
        tabs: {
          pending: 'Pending',
          approved: 'Approved',
          rejected: 'Rejected',
        },
      },
      notifications: {
        placeholder: 'There are no requests.',
        seeAll: 'See all requests',
        otherChanges: 'Pending authorization',
        ownChanges: 'Pending approvals',
        more: '({{items}} more)',
      },
    },
    // adjust with correct information of instruction
    notification: {
      title: 'Notifications',
      incoming: {
        fop: 'Pending approval: Incoming free of payment settlement instruction',
      },
    },
    overview: {
      asOfDate: 'As of {{date, DD/MM/YYYY}}',
    },
    scheduler: {
      current: 'Current',
      xeyes: {
        seeDetails: 'See details',
        title: 'Proceed with ticking the scheduler?',
        currencyTitle: 'Close «{{currency}} Detokenization»?',
        body: 'Upon confirmation the scheduler will be advanced from «{{previousEventLabel}}» to «{{nextEventLabel}}».',
        currencyBody: 'Upon confirmation the system will close «{{currency}} Detokenization».',
        action: {
          approve: 'Approve',
          cancel: 'Cancel',
        },
      },
      autoScheduler: {
        errorLabel: 'Autoscheduler error:',
        errorMessage:
          'The Autoscheduler has stopped due to the following error «{{errorMessage}}». Please resolve the issue or take appropriate action to restart the Scheduler manually.',
      },
      followingProcessingDate: 'Following Processing Date:',
    },
    onboarding: {
      overview: {
        title: 'Onboarding utilities',
        notAuthorized: 'You are not authorized to access this page',
        selectMember: 'Select member',
      },
      dataPropagation: {
        title: 'Data propagation',
        start: 'Start data propagation',
        status: {
          succeeded: 'Succeeded',
          failed: 'Failed',
          running: 'Running',
          starting: 'Started',
        },
        logDetails: 'Log details',
      },
    },
    asset: {
      details: {
        legend: {
          firstRow: 'mandatory fields',
          secondRow: {
            part1: 'fields that are',
            part2: 'non-modifiable',
            part3: 'when the asset is active',
          },
        },
      },
    },
    member: {
      details: {
        legend: {
          secondRow: {
            part1: 'fields that are',
            part2: 'non-modifiable',
            part3: 'when the member is active',
          },
        },
      },
    },
    legalEntity: {
      details: {
        legend: {
          secondRow: {
            part1: 'fields that are',
            part2: 'non-modifiable',
            part3: 'when the legal entity is active',
          },
        },
      },
    },
    pendingAction: {
      approveReject: 'Approve/Reject',
    },
  },
};

export default adminEn;
